import React, { useRef, useState, useEffect } from "react";

const BrandSection = () => {
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="bg-[#D4CFC7] pt-20 pb-10 sm:pt-28 sm:pb-12 lg:pt-36 lg:pb-16">
      <div className="max-w-4xl mx-auto px-6 lg:px-12 text-center">
        <div
          className={`transition-all duration-1000 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <div className="leading-[1.15] mb-8">
            <span className="font-inter text-xl sm:text-2xl lg:text-3xl text-[#9A9A9A] block">"</span>
            <span className="font-bebas text-4xl sm:text-5xl lg:text-7xl xl:text-8xl text-[#1A1A1A] tracking-[0.05em] block">
              STORIES THAT MAKE
            </span>
            <span className="font-inter text-xl sm:text-2xl lg:text-4xl italic text-[#8B7355] block mt-1">
              destinations felt
            </span>
            <span className="font-bebas text-4xl sm:text-5xl lg:text-7xl xl:text-8xl text-[#1A1A1A] tracking-[0.05em] block">
              NOT JUST
            </span>
            <span className="font-inter text-xl sm:text-2xl lg:text-4xl italic text-[#8B7355] block mt-1">
              seen
            </span>
            <span className="font-inter text-xl sm:text-2xl lg:text-3xl text-[#9A9A9A] block mt-2">"</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrandSection;
